// Third-party libs
require('../../../assets/lib/adapter-3.1.0.js');
require('../../../assets/lib/jquery/jquery-ui-1.10.3.min.js');

// Common
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/common/jv.i18n.js');
require('../../../assets/scripts/common/jv.Jobvite.Urls.js');
require('../../../assets/scripts/common/jv.BrowserDetails.js');
require('../../../assets/scripts/common/jv.Timer.js');
require('../../../assets/scripts/common/angajaxservice.js');
require('../../../assets/scripts/common/polyfills.js');

// Common Directives
require('../../../assets/scripts/common/directives/jv.PageRefresh.Directive.js');
require('../../../assets/scripts/common/directives/jv.PrivacyPolicy.Directives.js');

// Common Video Utilities
require('../../../assets/scripts/common/video/jquery.flash.js');
require('../../../assets/scripts/common/video/jv.VideoRecorder.js');
require('../../../assets/scripts/common/video/jv.VideoRecorder.Directive.js');
require('../../../assets/scripts/common/video/jv.VonageVideoRecorder.Directive.js');
require('../../../assets/scripts/common/video/jv.VideoPlayer.webpack.js');
require('../../../assets/scripts/common/video/jv.VideoPlayer.Directive.js');

// Videos (Jobseeker)
require('../../../assets/scripts/videos/jobseeker/jv.Videos.RequestExtensionModal.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.Svc.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.IntervieweeReview.Ctrl.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.Question.Ctrl.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.Playback.Ctrl.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.Router.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.Details.RootCtrl.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.Unreachable.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.App.Details.js');
require('../../../assets/scripts/videos/jobseeker/jv.Videos.Interviewee.Ctrl.js');
